// Quiet table of the list pages (styles/shared/_data_table.scss). One row per item; on narrow screens each
// row becomes a labelled block, the labels being the column headers.
// columns: [{ key, header, label?, render(row), className }]; `label` is the text of a header that is not a string.
// onRowClick(row): the whole row picks it with the mouse; keep a button in a cell for the keyboard, whose click
// reaches the row (no handler of its own, so the row runs once).
const DataTable = ({ columns, rows, getRowKey, ariaLabel, className = "", onRowClick }) => (
  <table className={`data_table ${className}`.trim()} aria-label={ariaLabel}>
    <thead>
      <tr>
        {columns.map((column) => (
          <th key={column.key} scope="col" className={column.className}>
            {column.header}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {rows.map((row) => (
        <tr
          key={getRowKey(row)}
          className={onRowClick ? "data_table_row_action" : undefined}
          onClick={onRowClick ? () => onRowClick(row) : undefined}
        >
          {columns.map((column) => (
            <td key={column.key} data-label={column.label ?? column.header} className={column.className}>
              {column.render(row)}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

export default DataTable;
